/**
 * Projektberater (Collection-Wizard)
 *
 * Wird einmal global geladen (defer) und initialisiert pro Section-Instance
 * auf der Page. Liquid-spezifische Werte (Collection-Handle/Title, Section-ID)
 * kommen aus data-* Attributen auf dem Section-Root; die Daten-Layer
 * (data-pb-products, data-pb-icon-names, data-pb-accessories, data-pb-i18n)
 * werden als JSON-Script-Tags geliefert.
 *
 * Eingebettete Doku der Events: docs/tracking-events.md.
 */
(function () {
  'use strict';

  function initProjektberater(root) {
    var SECTION_ID = root.getAttribute('data-section-id') || '';
    /* root via Argument injiziert */
    if (!root) return;

    /* Tracking-Helper: leitet an window.bekTrack weiter, sobald geladen.
       No-Op vor Init / wenn das Tracking-Snippet leer ist. Alle Projekt-
       berater-Events sind in docs/tracking-events.md dokumentiert. */
    var PB_COLLECTION_HANDLE = root.getAttribute('data-collection-handle') || '';
    var PB_COLLECTION_TITLE = root.getAttribute('data-collection-title') || '';
    function pbTrack(name, props) {
      if (typeof window.bekTrack !== 'function') return;
      try {
        var base = {
          section: 'projektberater',
          section_id: SECTION_ID,
          collection_handle: PB_COLLECTION_HANDLE,
          collection_title: PB_COLLECTION_TITLE
        };
        var p = props || {};
        for (var k in p) { if (p.hasOwnProperty(k)) base[k] = p[k]; }
        window.bekTrack(name, base);
      } catch (e) { /* graceful */ }
    }
    pbTrack('pb_view', {});

    /* --- Load collection products fallback --- */
    var collectionProducts = [];
    try {
      var cpEl = document.querySelector('[data-pb-collection-products-' + SECTION_ID + ']');
      if (cpEl) collectionProducts = JSON.parse(cpEl.textContent);
    } catch(e) { /* noop */ }

    /* --- Phase 5: Zubehoer-Map (handle → product info) --- */
    var pbAccessories = {};
    try {
      var acEl = root.querySelector('[data-pb-accessories]');
      if (acEl) pbAccessories = JSON.parse(acEl.textContent) || {};
    } catch(e) { /* graceful: leere Map */ }

    /* --- i18n-Map (Liquid hat alle JS-Strings via | t gerendert) --- */
    var pbI18n = {};
    try {
      var i18nEl = root.querySelector('[data-pb-i18n]');
      if (i18nEl) pbI18n = JSON.parse(i18nEl.textContent) || {};
    } catch(e) { /* graceful: leere Map → JS-Defaults greifen */ }

    /* --- State --- */
    var currentStep = 0;
    var selectedBlock = null;
    var coats = 2;
    var debounceTimer = null;

    /* Adaptive-Bridge (Phase 3): Hooks die initAdaptiveController setzt,
       damit der Legacy-Wizard-Code (goToStep/Prev/Restart) unverändert
       bleibt und der adaptive Mode trotzdem andocken kann. */
    var onLegacyStep = null;
    var onLegacyPrev = null;
    var onLegacyRestart = null;

    /* --- DOM refs --- */
    var track = root.querySelector('[data-pb-track]');
    var steps = root.querySelectorAll('[data-step]');
    var dots = root.querySelectorAll('[data-dot]');
    var lines = root.querySelectorAll('[data-line]');
    var cards = root.querySelectorAll('.pb__type-card');

    /* Calc refs */
    var calcTitle = root.querySelector('[data-pb-calc-title]');
    var calcSubtitle = root.querySelector('[data-pb-calc-subtitle]');
    var modeFlaeche = root.querySelector('[data-pb-mode="flaeche"]');
    var modeVolumen = root.querySelector('[data-pb-mode="volumen"]');
    var modeNone = root.querySelector('[data-pb-mode="none"]');
    var coatsRow = root.querySelector('[data-pb-coats-row]');
    var calcSummary = root.querySelector('.pb__calc-summary');

    var lengthInput = root.querySelector('[data-pb-length]');
    var widthInput = root.querySelector('[data-pb-width]');
    var vlengthInput = root.querySelector('[data-pb-vlength]');
    var vwidthInput = root.querySelector('[data-pb-vwidth]');
    var vdepthInput = root.querySelector('[data-pb-vdepth]');

    var areaDisplay = root.querySelector('[data-pb-area]');
    var volumeDisplay = root.querySelector('[data-pb-volume]');
    var coatsDisplay = root.querySelector('[data-pb-coats-display]');
    var verbrauchDisplay = root.querySelector('[data-pb-verbrauch-display]');
    var totalDisplay = root.querySelector('[data-pb-total]');

    /* Result refs */
    var resultCard = root.querySelector('[data-pb-result-card]');
    var resultNone = root.querySelector('[data-pb-result-none]');
    var resultImg = root.querySelector('[data-pb-result-img]');
    var resultLink = root.querySelector('[data-pb-result-link]');
    var resultMetaArea = root.querySelector('[data-pb-result-meta-area]');
    var resultMetaTotal = root.querySelector('[data-pb-result-meta-total]');
    var resultVariant = root.querySelector('[data-pb-result-variant]');
    var resultPrice = root.querySelector('[data-pb-result-price]');
    var atcBtn = root.querySelector('[data-pb-atc]');

    /* Phase 5 result-extensions */
    var aufbauContainer = root.querySelector('[data-pb-result-aufbau]');
    var aufbauText = root.querySelector('[data-pb-result-aufbau-text]');
    var zubehoerContainer = root.querySelector('[data-pb-result-zubehoer]');
    var zubehoerList = root.querySelector('[data-pb-result-zubehoer-list]');
    var resultFarbe = root.querySelector('[data-pb-result-farbe]');
    var bundleTotalEl = root.querySelector('[data-pb-bundle-total]');
    /* Aktuell ausgewählter Produkt-Preis (Cents) für Bundle-Total-Recompute */
    var currentProductCents = 0;

    /* --- Helpers --- */
    function pbEscape(s) {
      var d = document.createElement('div');
      d.appendChild(document.createTextNode(s == null ? '' : String(s)));
      return d.innerHTML;
    }

    function fmtDe(n, decimals) {
      var d = decimals || 1;
      return n.toLocaleString('de-DE', { minimumFractionDigits: d, maximumFractionDigits: d });
    }

    function parseWeight(title) {
      if (!title) return null;
      /* N×M-Multipacks ("10 x 1 kg", "6x500ml") MÜSSEN vor den Einzel-
         Patterns matchen — sonst greift z. B. /(\d+)\s*kg/ auf "1 kg" und
         der Faktor 10 geht verloren. Spiegel des Fixes aus
         main-product-datenblatt.liquid (Commit c52d9c2). */
      var mxKg = title.match(/(\d+)\s*x\s*(\d+(?:[.,]\d+)?)\s*kg\b/i);
      if (mxKg) return parseInt(mxKg[1], 10) * parseFloat(mxKg[2].replace(',', '.'));
      var mxL = title.match(/(\d+)\s*x\s*(\d+(?:[.,]\d+)?)\s*(?:liter|l)\b/i);
      if (mxL) return parseInt(mxL[1], 10) * parseFloat(mxL[2].replace(',', '.'));
      var mxG = title.match(/(\d+)\s*x\s*(\d+(?:[.,]\d+)?)\s*g\b/i);
      if (mxG) return parseInt(mxG[1], 10) * parseFloat(mxG[2].replace(',', '.')) / 1000;
      var mxMl = title.match(/(\d+)\s*x\s*(\d+(?:[.,]\d+)?)\s*ml\b/i);
      if (mxMl) return parseInt(mxMl[1], 10) * parseFloat(mxMl[2].replace(',', '.')) / 1000;

      var m = title.match(/(?:^|[\s\/])(\d+(?:[.,]\d+)?)\s*kg/i);
      if (m) return parseFloat(m[1].replace(',', '.'));
      m = title.match(/(?:^|[\s\/])(\d+(?:[.,]\d+)?)\s*[Ll](?:iter)?/i);
      if (m) return parseFloat(m[1].replace(',', '.'));
      m = title.match(/(?:^|[\s\/])(\d+(?:[.,]\d+)?)\s*ml(?!\w)/i);
      if (m) return parseFloat(m[1].replace(',', '.')) / 1000;
      m = title.match(/(?:^|[\s\/])(\d+(?:[.,]\d+)?)\s*g(?!\w)/i);
      if (m) return parseFloat(m[1].replace(',', '.')) / 1000;
      m = title.match(/(?:^|[\s\/])(\d+(?:[.,]\d+)?)\s*(?:qm|m[²2])/i);
      if (m) return parseFloat(m[1].replace(',', '.'));
      return null;
    }

    /* Detect whether variants use weight (kg/L/g) or area (qm/m²) units */
    function detectVariantUnit(variants) {
      for (var i = 0; i < variants.length; i++) {
        var t = variants[i].title || '';
        if (/\d[\s]*kg/i.test(t)) return 'kg';
        if (/\d[\s]*[Ll](?:iter)?/i.test(t)) return 'l';
        if (/\d[\s]*(?:qm|m[²2])/i.test(t)) return 'qm';
        if (/\d[\s]*g(?!\w)/i.test(t)) return 'g';
      }
      return 'kg';
    }

    function findBestVariant(variants, requiredKg) {
      var parsed = [];
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var w = parseWeight(v.title);
        if (w !== null && v.available) {
          parsed.push({ id: v.id, title: v.title, weight: w, price: v.price });
        }
      }
      parsed.sort(function(a, b) { return a.weight - b.weight; });

      for (var j = 0; j < parsed.length; j++) {
        if (parsed[j].weight >= requiredKg) return parsed[j];
      }
      return parsed.length > 0 ? parsed[parsed.length - 1] : null;
    }

    /* Pack required kg into multiple variants greedily (largest first, then
       smaller for the remainder). Fixes the bug where only 1x the largest
       variant was added even when the customer needed several. */
    function packVariants(variants, requiredKg) {
      var parsed = [];
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var w = parseWeight(v.title);
        if (w !== null && v.available && w > 0) {
          parsed.push({ id: v.id, title: v.title, weight: w, price: v.price });
        }
      }
      if (parsed.length === 0) return [];

      parsed.sort(function(a, b) { return b.weight - a.weight; });
      var smallest = parsed[parsed.length - 1];

      var remaining = requiredKg;
      var packs = [];

      for (var p = 0; p < parsed.length; p++) {
        var size = parsed[p];
        var count;
        if (size === smallest) {
          count = Math.ceil(remaining / size.weight);
        } else {
          count = Math.floor(remaining / size.weight);
        }
        if (count > 0) {
          packs.push({ variant: size, count: count });
          remaining -= count * size.weight;
          if (remaining <= 0) break;
        }
      }

      return packs;
    }

    function describePack(packs) {
      return packs.map(function(p) { return p.count + '\u00D7 ' + p.variant.title; }).join(' + ');
    }

    function packTotalPriceCents(packs) {
      return packs.reduce(function(sum, p) { return sum + (p.variant.price * p.count); }, 0);
    }

    function packTotalKg(packs) {
      return packs.reduce(function(sum, p) { return sum + (p.variant.weight * p.count); }, 0);
    }

    /* Kleinste verfuegbare Variante per parseWeight (aufsteigend sortiert).
       Variants ohne parsbare Groesse landen ans Ende; wenn keine Variante
       eine Groesse liefert, faellt der Helper auf die erste verfuegbare zurueck.
       Wird im non-flaeche Result-Pfad als Standardvariante verwendet. */
    function pickSmallestAvailable(variants) {
      if (!variants || variants.length === 0) return null;
      var withWeight = [];
      var firstAvail = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (!v.available) continue;
        if (!firstAvail) firstAvail = v;
        var w = parseWeight(v.title);
        if (w !== null && w > 0) withWeight.push({ v: v, w: w });
      }
      if (withWeight.length > 0) {
        withWeight.sort(function(a, b) { return a.w - b.w; });
        return withWeight[0].v;
      }
      return firstAvail;
    }

    /* Mengenrechner-Step (idx=1) ist sinnvoll fuer:
         - Flaechen-Produkte
         - Volumen-Produkte MIT gesetzter Dichte (custom.dichte_kg_l > 0)
       Saugfaehigkeit, none, unbekannte Modi oder Volumen ohne Dichte
       springen direkt zum Ergebnis-Step (idx=2). Der Volumen-Skip war
       das Interim-Verhalten — sobald Ruben die Dichte am Produkt pflegt,
       schaltet sich der Rechner automatisch dazu. */
    function productNeedsCalculator() {
      if (!selectedBlock) return true;
      var m = selectedBlock.getAttribute('data-calc-mode') || 'flaeche';
      if (m === 'flaeche') return true;
      if (m === 'volumen') {
        var d = parseFloat(selectedBlock.getAttribute('data-dichte')) || 0;
        return d > 0;
      }
      return false;
    }

    /* --- Step Navigation --- */
    function goToStep(idx) {
      if (idx < 0 || idx > 2) return;
      /* Vorwaerts-Skip: Calculator-Step ueberspringen, wenn das Produkt
         keinen Mengenrechner braucht (Volumen / Saugfaehigkeit / none). */
      if (idx === 1 && idx > currentStep && !productNeedsCalculator()) {
        idx = 2;
      }
      track.classList.add('is-sliding');
      track.style.transform = 'translateX(-' + (idx * 100) + '%)';

      for (var i = 0; i < steps.length; i++) {
        if (i === idx) {
          steps[i].classList.add('step--active');
        } else {
          steps[i].classList.remove('step--active');
        }
      }

      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('is-active', d === idx);
        dots[d].classList.toggle('is-completed', d < idx);
      }

      for (var l = 0; l < lines.length; l++) {
        lines[l].classList.toggle('is-active', l < idx);
      }

      currentStep = idx;

      if (idx === 1) setupCalculator();
      if (idx === 2) showResult();

      setTimeout(function() {
        var activeStep = steps[idx];
        var focusTarget = activeStep.querySelector('button:not([disabled]), input, [tabindex="0"]');
        if (focusTarget) focusTarget.focus();
        track.classList.remove('is-sliding');
      }, 320);

      if (typeof onLegacyStep === 'function') onLegacyStep(idx);
    }

    /* --- Step 1: Card Selection --- */
    function selectCard(card) {
      for (var i = 0; i < cards.length; i++) {
        cards[i].classList.remove('is-selected');
        cards[i].setAttribute('aria-pressed', 'false');
      }
      card.classList.add('is-selected');
      card.setAttribute('aria-pressed', 'true');
      selectedBlock = card;

      var nextBtns = steps[0].querySelectorAll('[data-pb-next]');
      for (var n = 0; n < nextBtns.length; n++) {
        nextBtns[n].disabled = false;
      }
    }

    for (var c = 0; c < cards.length; c++) {
      (function(card) {
        card.addEventListener('click', function() { selectCard(card); });
        card.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            selectCard(card);
          }
        });
      })(cards[c]);
    }

    /* --- Step 2: Calculator Setup --- */
    function setupCalculator() {
      if (!selectedBlock) return;
      var mode = selectedBlock.getAttribute('data-calc-mode') || 'flaeche';
      var verbrauch = parseFloat(selectedBlock.getAttribute('data-verbrauch')) || 0.3;
      var dichte = parseFloat(selectedBlock.getAttribute('data-dichte')) || 0;
      coats = parseInt(selectedBlock.getAttribute('data-anstriche'), 10) || 2;

      coatsDisplay.textContent = coats;

      modeFlaeche.style.display = mode === 'flaeche' ? '' : 'none';
      modeVolumen.style.display = mode === 'volumen' ? '' : 'none';
      modeNone.style.display = mode === 'none' ? '' : 'none';

      if (mode === 'none' || mode === 'volumen') {
        /* Anstriche-Slider blendet auch im Volumen-Modus aus — Material
           wird nicht in Schichten gegossen, coats wuerde nur verwirren. */
        coatsRow.style.display = 'none';
        calcSummary.style.display = mode === 'none' ? 'none' : '';
      } else {
        coatsRow.style.display = '';
        calcSummary.style.display = '';
      }

      if (mode === 'flaeche') {
        calcTitle.textContent = pbI18n.calc_area_title || 'Flaechenberechnung';
        calcSubtitle.textContent = pbI18n.calc_area_subtitle || 'Geben Sie Laenge und Breite Ihres Projekts ein';
        /* verbrauch_pro_qm ist in g/m\u00B2 (bzw. ml/m\u00B2) gespeichert \u2192 f\u00FCr die
           Anzeige in kg/m\u00B2 durch 1000 teilen. Spiegel zur Berechnung in
           calculate() und showResult(). */
        verbrauchDisplay.textContent = fmtDe(verbrauch / 1000) + ' ' + (pbI18n.summary_verbrauch_qm_unit || 'kg/m\u00B2');
      } else if (mode === 'volumen') {
        calcTitle.textContent = pbI18n.calc_volume_title || 'Volumenberechnung';
        calcSubtitle.textContent = pbI18n.calc_volume_subtitle || 'Geben Sie die Abmessungen Ihres Projekts ein';
        /* Volumen-Modus zeigt die Materialdichte aus custom.dichte_kg_l
           (kg pro Liter). Berechnung: kg = Liter \u00D7 Dichte. */
        verbrauchDisplay.textContent = fmtDe(dichte) + ' ' + (pbI18n.summary_dichte_unit || 'kg/L');
      } else {
        calcTitle.textContent = pbI18n.calc_none_title || 'Produktempfehlung';
        calcSubtitle.textContent = pbI18n.calc_none_subtitle || 'Kein Kalkulator für diesen Projekttyp erforderlich';
      }

      calculate();
    }

    /* Einheitliche Mengen-Mathematik fuer calculate() und showResult().
         Flaeche:  totalKg = m\u00B2 \u00D7 g/m\u00B2 \u00D7 coats / 1000
         Volumen:  totalKg = Liter \u00D7 Dichte (kg/L) \u2014 coats irrelevant,
                   Material wird nicht in Schichten gegossen.
                   measure ist in m\u00B3, also \u00D7 1000 fuer Liter.
       Ohne Dichte (= Interim-Pfad) wird 0 zurueckgegeben; der Calculator
       wird in dem Fall ueber productNeedsCalculator() ohnehin uebersprungen. */
    function computeTotalKg(mode, measure, verbrauch, coatsArg, dichteKgL) {
      if (mode === 'flaeche' || mode === 'saugfaehigkeit') {
        return (measure * verbrauch * coatsArg) / 1000;
      }
      if (mode === 'volumen') {
        if (!(dichteKgL > 0)) return 0;
        var liter = measure * 1000;
        return liter * dichteKgL;
      }
      return 0;
    }

    function calculate() {
      if (!selectedBlock) return;
      var mode = selectedBlock.getAttribute('data-calc-mode') || 'flaeche';
      var verbrauch = parseFloat(selectedBlock.getAttribute('data-verbrauch')) || 0.3;
      var dichte = parseFloat(selectedBlock.getAttribute('data-dichte')) || 0;

      if (mode === 'none') {
        totalDisplay.textContent = '--';
        return;
      }

      var measure = 0;
      if (mode === 'flaeche') {
        var l = parseFloat(lengthInput.value) || 0;
        var w = parseFloat(widthInput.value) || 0;
        measure = l * w;
        areaDisplay.textContent = fmtDe(measure) + ' m\u00B2';
      } else {
        var vl = parseFloat(vlengthInput.value) || 0;
        var vw = parseFloat(vwidthInput.value) || 0;
        var vd = parseFloat(vdepthInput.value) || 0;
        measure = vl * vw * vd;
        volumeDisplay.textContent = fmtDe(measure) + ' m\u00B3';
      }

      var totalKg = computeTotalKg(mode, measure, verbrauch, coats, dichte);
      totalDisplay.textContent = totalKg > 0 ? fmtDe(totalKg, 2) + ' kg' : '--';

      /* pb_calc_used feuert nur, wenn der User sich tatsaechlich an den
         Eingaben verandert hat (measure > 0). Throttle ueber einen Marker
         am selectedBlock, damit jeder Strich nicht ein Event ausloest. */
      if (typeof window !== 'undefined' && measure > 0 && selectedBlock) {
        if (!selectedBlock.__pbCalcUsedSent) {
          selectedBlock.__pbCalcUsedSent = true;
          pbTrack('pb_calc_used', {
            product_handle: selectedBlock.getAttribute('data-product-handle') || '',
            calc_mode: mode,
            measure: Math.round(measure * 100) / 100,
            total_kg: Math.round(totalKg * 100) / 100,
            coats: coats
          });
        }
      }
    }

    function debounceCalc() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(calculate, 200);
    }

    [lengthInput, widthInput, vlengthInput, vwidthInput, vdepthInput].forEach(function(input) {
      if (input) input.addEventListener('input', debounceCalc);
    });

    /* Coats controls */
    var coatsMinus = root.querySelector('[data-pb-coats-minus]');
    var coatsPlus = root.querySelector('[data-pb-coats-plus]');

    if (coatsMinus) {
      coatsMinus.addEventListener('click', function() {
        if (coats > 1) { coats--; coatsDisplay.textContent = coats; calculate(); }
      });
    }
    if (coatsPlus) {
      coatsPlus.addEventListener('click', function() {
        if (coats < 5) { coats++; coatsDisplay.textContent = coats; calculate(); }
      });
    }

    /* --- Step 3: Result --- */
    function getProductData() {
      /* Try to get product from block settings first */
      var productTitle = selectedBlock.getAttribute('data-product-title');
      var productUrl = selectedBlock.getAttribute('data-product-url');
      var productImage = selectedBlock.getAttribute('data-product-image');
      var variantsJson = selectedBlock.getAttribute('data-product-variants');

      if (productTitle && variantsJson) {
        var variants = [];
        try { variants = JSON.parse(variantsJson); } catch(e) {}
        return {
          title: productTitle,
          url: productUrl || '#',
          image: productImage || '',
          variants: variants
        };
      }

      /* Fallback: find the best matching product from the collection.
         Prefer products with more parseable variant sizes and larger
         pack sizes — these are usually the main products, not accessories. */
      if (collectionProducts.length > 0) {
        var bestProduct = null;
        var bestScore = -1;

        for (var i = 0; i < collectionProducts.length; i++) {
          var cp = collectionProducts[i];
          if (!cp.variants || cp.variants.length === 0) continue;

          var parseableCount = 0;
          var maxSize = 0;
          for (var v = 0; v < cp.variants.length; v++) {
            var w = parseWeight(cp.variants[v].title);
            if (w !== null) {
              parseableCount++;
              if (w > maxSize) maxSize = w;
            }
          }
          /* Score: products with more parseable variants score higher.
             Tie-break by largest variant size (main products have bigger packs). */
          var score = parseableCount * 1000 + maxSize;
          if (cp.available) score += 5000; /* prefer available products */
          if (score > bestScore) {
            bestScore = score;
            bestProduct = cp;
          }
        }

        if (bestProduct) {
          return {
            title: bestProduct.title,
            url: bestProduct.url,
            image: bestProduct.image || '',
            variants: bestProduct.variants
          };
        }

        /* Last resort: first product */
        var first = collectionProducts[0];
        return {
          title: first.title,
          url: first.url,
          image: first.image || '',
          variants: first.variants || []
        };
      }

      return null;
    }

    function showResult() {
      if (!selectedBlock) {
        resultCard.style.display = 'none';
        resultNone.style.display = 'block';
        return;
      }

      var product = getProductData();
      var mode = selectedBlock.getAttribute('data-calc-mode') || 'flaeche';
      var verbrauch = parseFloat(selectedBlock.getAttribute('data-verbrauch')) || 0.3;

      if (!product) {
        resultCard.style.display = 'none';
        resultNone.style.display = 'block';
        return;
      }

      var measure = 0;
      var measureLabel = '';

      if (mode === 'flaeche') {
        measure = (parseFloat(lengthInput.value) || 0) * (parseFloat(widthInput.value) || 0);
        measureLabel = fmtDe(measure) + ' m\u00B2';
      } else if (mode === 'volumen') {
        measure = (parseFloat(vlengthInput.value) || 0) * (parseFloat(vwidthInput.value) || 0) * (parseFloat(vdepthInput.value) || 0);
        measureLabel = fmtDe(measure) + ' m\u00B3';
      }

      /* Identische Formel wie im Live-Rechner (computeTotalKg) \u2014 verhindert
         Drift zwischen Calculator-Anzeige und Ergebnis-Karte. */
      var dichteRes = parseFloat(selectedBlock.getAttribute('data-dichte')) || 0;
      var totalKg = (mode === 'none') ? 0 : computeTotalKg(mode, measure, verbrauch, coats, dichteRes);

      /* Update result display */
      resultLink.textContent = product.title;
      resultLink.href = product.url;

      if (product.image) {
        resultImg.src = product.image;
        resultImg.alt = product.title;
        resultImg.closest('.pb__result-image').style.display = '';
      } else {
        resultImg.closest('.pb__result-image').style.display = 'none';
      }

      /* Gewählter Farbton aus Handoff/Farbton-Step (data-product-farbe). */
      if (resultFarbe) {
        var farbeVal = selectedBlock.getAttribute('data-product-farbe') || '';
        if (farbeVal) {
          var farbeLbl = pbI18n.result_farbe_label || 'Farbton';
          resultFarbe.innerHTML = pbEscape(farbeLbl) + ': <strong>' + pbEscape(farbeVal) + '</strong>';
          resultFarbe.hidden = false;
        } else {
          resultFarbe.hidden = true;
          resultFarbe.textContent = '';
        }
      }

      if ((mode === 'flaeche' || mode === 'volumen') && totalKg > 0) {
        var variantUnit = detectVariantUnit(product.variants);
        var packValue;
        var unitLabel = (variantUnit === 'qm') ? 'm\u00B2' : (variantUnit === 'l') ? 'L' : 'kg';

        var areaTpl = pbI18n.result_project_area || 'Projektfl\u00E4che: __PB_AREA__';
        var totalTpl = pbI18n.result_total_demand || 'Gesamtbedarf: __PB_TOTAL__';
        var totalAnTpl = pbI18n.result_total_demand_with_anstriche || 'Gesamtbedarf: __PB_TOTAL__ (__PB_ANSTRICHE__ Anstriche)';

        if (variantUnit === 'qm') {
          /* Area-based product (Sets in qm): pack by area, not by kg */
          packValue = measure;
          resultMetaArea.textContent = areaTpl.replace('__PB_AREA__', measureLabel);
          resultMetaTotal.textContent = totalTpl.replace('__PB_TOTAL__', fmtDe(measure, 1) + ' m\u00B2');
        } else {
          /* Weight/volume-based product (kg/L/g): pack by calculated amount */
          packValue = totalKg;
          resultMetaArea.textContent = areaTpl.replace('__PB_AREA__', measureLabel);
          /* Anstriche-Suffix nur fuer Flaeche — bei Volumen ist coats
             irrelevant und wuerde verwirren. */
          if (mode === 'volumen') {
            resultMetaTotal.textContent = totalTpl.replace('__PB_TOTAL__', fmtDe(totalKg, 2) + ' ' + unitLabel);
          } else {
            resultMetaTotal.textContent = totalAnTpl
              .replace('__PB_TOTAL__', fmtDe(totalKg, 2) + ' ' + unitLabel)
              .replace('__PB_ANSTRICHE__', String(coats));
          }
        }

        var packs = packVariants(product.variants, packValue);
        if (packs.length > 0) {
          var totalCents = packTotalPriceCents(packs);
          var packSizeLabel = fmtDe(packTotalKg(packs), (variantUnit === 'qm') ? 1 : 2) + ' ' + unitLabel;
          var recTpl = pbI18n.result_recommended || 'Empfohlen: __PB_PACK__ (__PB_SIZE__)';
          resultVariant.textContent = recTpl
            .replace('__PB_PACK__', describePack(packs))
            .replace('__PB_SIZE__', packSizeLabel);
          resultVariant.style.display = '';
          resultPrice.textContent = (totalCents / 100).toFixed(2).replace('.', ',') + ' \u20AC';
          currentProductCents = totalCents;
          atcBtn.disabled = false;
          atcBtn.setAttribute('data-pack', JSON.stringify(packs.map(function(p) {
            return { id: p.variant.id, quantity: p.count };
          })));
        } else {
          resultVariant.style.display = 'none';
          var fp = (product.variants[0] && product.variants[0].price) ? (product.variants[0].price / 100).toFixed(2).replace('.', ',') + ' \u20AC' : '';
          resultPrice.textContent = fp;
          currentProductCents = (product.variants[0] && product.variants[0].price) || 0;
          atcBtn.disabled = true;
          atcBtn.removeAttribute('data-pack');
        }
      } else {
        /* Non-Flaeche (Volumen / Saugfaehigkeit / none) ODER Flaeche ohne
           Inputs: keine Mengen-/Gebinde-Zeile, Standardvariante = kleinste
           verfuegbare (Menge 1). Verhindert irrefuehrende Zahlen bei
           Produkten, fuer die der Mengenrechner-Step uebersprungen wurde. */
        resultMetaArea.textContent = '';
        resultMetaTotal.textContent = '';
        resultVariant.style.display = 'none';

        var defaultVariant = pickSmallestAvailable(product.variants);
        if (defaultVariant) {
          var pf = (defaultVariant.price / 100).toFixed(2).replace('.', ',');
          resultPrice.textContent = pf + ' \u20AC';
          currentProductCents = defaultVariant.price || 0;
          atcBtn.disabled = false;
          atcBtn.setAttribute('data-pack', JSON.stringify([{ id: defaultVariant.id, quantity: 1 }]));
        } else {
          resultPrice.textContent = '';
          currentProductCents = 0;
          atcBtn.disabled = true;
          atcBtn.removeAttribute('data-pack');
        }
      }

      /* Phase 5: Aufbauempfehlung + Zubehör rendern. Bundle-Total nach
         Zubehör-Render aktualisieren — Render setzt frische Checkboxen. */
      renderAufbau();
      renderZubehoer();
      updateBundleTotal();

      resultCard.style.display = '';
      resultNone.style.display = 'none';
    }

    /* Bundle-Total: Produkt-Preis + Summe aller angekreuzten Zubehör-Preise.
       Wird in showResult() initial + bei jedem Zubehör-Change neu berechnet. */
    function updateBundleTotal() {
      if (!bundleTotalEl) return;
      var sum = currentProductCents;
      if (zubehoerList) {
        var checks = zubehoerList.querySelectorAll('input.pb__zubehoer-check:checked');
        for (var i = 0; i < checks.length; i++) {
          var p = parseInt(checks[i].getAttribute('data-price'), 10) || 0;
          sum += p;
        }
      }
      bundleTotalEl.textContent = (sum / 100).toFixed(2).replace('.', ',') + ' €';
    }

    function renderAufbau() {
      if (!aufbauContainer || !aufbauText) return;
      var raw = selectedBlock && selectedBlock.getAttribute('data-product-aufbau');
      var items = [];
      if (raw && raw !== 'null' && raw !== '') {
        try {
          var parsed = JSON.parse(raw);
          if (Array.isArray(parsed)) items = parsed;
          else if (parsed && typeof parsed === 'object') items = [parsed];
          else if (typeof parsed === 'string' && parsed.trim()) items = [{ text: parsed }];
        } catch(e) {
          /* Legacy: rohen String anzeigen, statt zu verschlucken. */
          if (raw.trim()) items = [{ text: raw }];
        }
      }
      if (items.length === 0) {
        aufbauContainer.hidden = true;
        aufbauText.innerHTML = '';
        return;
      }
      var viewLbl = pbI18n.aufbau_view_product || 'Produkt ansehen';
      aufbauText.innerHTML = '';
      items.forEach(function(it, idx) {
        var step = document.createElement('div');
        step.className = 'pb__aufbau-step';
        var num = (it.step != null && it.step !== '') ? it.step : (idx + 1);
        var html = '<span class="pb__aufbau-num">' + pbEscape(String(num)) + '</span>' +
          '<div class="pb__aufbau-body">';
        if (it.title) html += '<h5 class="pb__aufbau-step-title">' + pbEscape(it.title) + '</h5>';
        if (it.text)  html += '<p class="pb__aufbau-step-text">' + pbEscape(it.text) + '</p>';
        if (it.product_handle) {
          html += '<a href="/products/' + pbEscape(it.product_handle) +
                  '" class="pb__aufbau-step-link">' + pbEscape(viewLbl) + ' →</a>';
        }
        html += '</div>';
        step.innerHTML = html;
        aufbauText.appendChild(step);
      });
      aufbauContainer.hidden = false;
    }

    function renderZubehoer() {
      if (!zubehoerContainer || !zubehoerList) return;
      var zuRaw = selectedBlock && selectedBlock.getAttribute('data-product-zubehoer');
      var handles = [];
      try { handles = zuRaw ? JSON.parse(zuRaw) : []; } catch(e) { handles = []; }

      var items = [];
      for (var i = 0; i < handles.length; i++) {
        var info = pbAccessories[handles[i]];
        if (info) items.push({ handle: handles[i], info: info });
      }

      if (items.length === 0) {
        zubehoerContainer.hidden = true;
        zubehoerList.innerHTML = '';
        return;
      }

      zubehoerList.innerHTML = '';
      items.forEach(function(item) {
        var info = item.info;
        var unavailable = !info.available || !info.variant_id;
        var label = document.createElement('label');
        label.className = 'pb__zubehoer-item' + (unavailable ? ' pb__zubehoer-item--unavailable' : '');
        var imgHtml = info.image
          ? '<img src="' + pbEscape(info.image) + '" alt="" class="pb__zubehoer-img" loading="lazy">'
          : '<div class="pb__zubehoer-img" aria-hidden="true"></div>';
        var priceStr = (info.price / 100).toFixed(2).replace('.', ',') + ' €';
        var titleSuffix = unavailable ? (pbI18n.result_zubehoer_unavailable || ' (nicht verfügbar)') : '';
        label.innerHTML =
          '<input type="checkbox" class="pb__zubehoer-check" value="' + pbEscape(String(info.variant_id || 0)) +
            '" data-handle="' + pbEscape(item.handle) +
            '" data-price="' + pbEscape(String(info.price || 0)) + '"' +
            (unavailable ? ' disabled' : '') + '>' +
          imgHtml +
          '<div class="pb__zubehoer-info">' +
            '<span class="pb__zubehoer-name">' + pbEscape(info.title) + pbEscape(titleSuffix) + '</span>' +
            '<span class="pb__zubehoer-price">' + priceStr + '</span>' +
          '</div>';

        /* Varianten-Dropdown (zentral sortiert), wenn das Zubehoer mehrere
           Varianten hat — Auswahl aktualisiert Checkbox-Value + Preis. */
        if (!unavailable && window.BekateqVariants && info.variants && info.variants.length > 1) {
          var infoWrap = label.querySelector('.pb__zubehoer-info');
          var check = label.querySelector('.pb__zubehoer-check');
          var priceEl = label.querySelector('.pb__zubehoer-price');
          var fmtEur = function (cents) {
            return (cents / 100).toFixed(2).replace('.', ',') + ' €';
          };
          var sel = window.BekateqVariants.buildSelect(info.variants, {
            className: 'pb__zubehoer-variant',
            formatMoney: fmtEur,
          });
          sel.style.cssText = 'display:block;width:100%;margin-top:6px;padding:8px 30px 8px 10px;font-size:13px;font-weight:500;border:1.5px solid #b5b5b5;border-radius:8px;background-color:#fff;cursor:pointer;appearance:none;-webkit-appearance:none;background-image:url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'12\' height=\'8\' viewBox=\'0 0 12 8\'%3E%3Cpath d=\'M1 1l5 5 5-5\' fill=\'none\' stroke=\'%231a1a1a\' stroke-width=\'2\' stroke-linecap=\'round\'/%3E%3C/svg%3E");background-repeat:no-repeat;background-position:right 10px center;';
          var syncAccessory = function () {
            var opt = sel.options[sel.selectedIndex];
            if (!opt || !check) return;
            check.value = sel.value;
            check.setAttribute('data-price', opt.getAttribute('data-price') || '0');
            if (priceEl) priceEl.textContent = fmtEur(parseInt(opt.getAttribute('data-price'), 10) || 0);
            updateBundleTotal();
          };
          sel.addEventListener('change', syncAccessory);
          if (infoWrap) infoWrap.appendChild(sel);
          syncAccessory();
        }

        zubehoerList.appendChild(label);
      });
      zubehoerContainer.hidden = false;
    }

    /* Einmaliger Listener auf der Zubehör-Liste (Event-Delegation) — wird
       nicht in renderZubehoer registriert, sonst wären Mehrfach-Listener
       bei Restart möglich. */
    if (zubehoerList) {
      zubehoerList.addEventListener('change', function(e) {
        if (e.target && e.target.classList && e.target.classList.contains('pb__zubehoer-check')) {
          updateBundleTotal();
        }
      });
    }

    /* --- ATC Button ---
       Nutzt BekateqCart.add() damit Header-Cart-Bubble, .header__cart-count-number
       und der Cart-Drawer ueber Section-Rendering aktualisiert + geoeffnet werden
       (Rubens Feedback: Items landeten im Cart, aber UI blieb stehen). Fallback
       bleibt drin, falls bekateq-cart.js (theme.liquid Z. 477) nicht geladen wurde. */
    if (atcBtn) {
      atcBtn.addEventListener('click', function() {
        var packRaw = atcBtn.getAttribute('data-pack');
        if (!packRaw || atcBtn.disabled) return;

        /* Variant-Lookup fuer GA4-Items (item_name, price). Kommt aus dem
           data-product-variants Attribut, das handoffToCalculator gesetzt hat. */
        var productVariants = [];
        try { productVariants = JSON.parse(selectedBlock.getAttribute('data-product-variants') || '[]') || []; }
        catch (e) {}
        var variantMap = {};
        for (var vm = 0; vm < productVariants.length; vm++) {
          if (productVariants[vm] && productVariants[vm].id) {
            variantMap[productVariants[vm].id] = productVariants[vm];
          }
        }
        var productTitle = selectedBlock.getAttribute('data-product-title') || '';
        var productHandle = selectedBlock.getAttribute('data-product-handle') || '';

        var items;
        var ga4Items = [];
        try {
          items = JSON.parse(packRaw).map(function(p) {
            var id = parseInt(p.id, 10);
            var qty = parseInt(p.quantity, 10);
            if (id > 0 && qty > 0) {
              var v = variantMap[id];
              ga4Items.push({
                item_id: String(id),
                item_name: productTitle + (v && v.title ? ' – ' + v.title : ''),
                item_brand: 'BEKATEQ',
                quantity: qty,
                price: v ? (v.price / 100) : 0
              });
            }
            return { id: id, quantity: qty };
          }).filter(function(p) { return p.id > 0 && p.quantity > 0; });
        } catch (e) {
          return;
        }
        if (items.length === 0) return;

        var productItemCount = items.length;
        /* Phase 5: angekreuzte Zubehoer-Varianten anhaengen (alle in EINEM Cart-Request) */
        if (zubehoerList) {
          var checks = zubehoerList.querySelectorAll('input.pb__zubehoer-check:checked');
          for (var ci = 0; ci < checks.length; ci++) {
            var vid = parseInt(checks[ci].value, 10);
            if (vid > 0) {
              items.push({ id: vid, quantity: 1 });
              var addonHandle = checks[ci].getAttribute('data-handle');
              var info = pbAccessories[addonHandle];
              ga4Items.push({
                item_id: String(vid),
                item_name: (info && info.title) || ('Zubehör ' + vid),
                item_brand: 'BEKATEQ',
                item_category: 'Zubehör',
                quantity: 1,
                price: info ? (info.price / 100) : 0
              });
            }
          }
        }

        /* Option B: Line-Item-Property _quelle setzt jeden Cart-Eintrag aus
           dem Berater als "projektberater" — landet im purchase-Event als
           item-Property und erlaubt Umsatz-Attribution pro Quelle. Unterstrich-
           Prefix → hidden in Shopify-UIs, sichtbar in der Cart-API. */
        items = items.map(function(it) {
          return { id: it.id, quantity: it.quantity, properties: { _quelle: 'projektberater' } };
        });

        /* GA4-Standard: value als EUR-Float, currency, items[]. value_cents
           bleibt fuer eigene BigQuery-Reports / Debugging. */
        var addonItemCount = items.length - productItemCount;
        var totalEur = ga4Items.reduce(function(s, it) { return s + (it.price || 0) * (it.quantity || 0); }, 0);
        totalEur = Math.round(totalEur * 100) / 100;
        pbTrack('pb_atc_bundle', {
          product_handle: productHandle,
          calc_mode: selectedBlock.getAttribute('data-calc-mode') || '',
          farbe: selectedBlock.getAttribute('data-product-farbe') || '',
          item_count: items.length,
          product_pack_count: productItemCount,
          addon_count: addonItemCount,
          value_cents: (typeof currentProductCents === 'number' ? currentProductCents : 0),
          value: totalEur,
          currency: 'EUR',
          items: ga4Items
        });

        var originalHTML = atcBtn.innerHTML;
        var successHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6L9 17l-5-5"/></svg> ' + (pbI18n.atc_success || 'Hinzugefügt!');

        function pbFlashSuccess() {
          atcBtn.innerHTML = successHTML;
          atcBtn.classList.add('pb__atc-btn--success');
          setTimeout(function() {
            atcBtn.innerHTML = originalHTML;
            atcBtn.classList.remove('pb__atc-btn--success');
            atcBtn.disabled = false;
          }, 2500);
        }
        function pbFlashError() {
          atcBtn.innerHTML = pbI18n.atc_error || 'Fehler \u2013 bitte erneut versuchen';
          setTimeout(function() {
            atcBtn.innerHTML = originalHTML;
            atcBtn.disabled = false;
          }, 2500);
        }

        if (window.BekateqCart && typeof window.BekateqCart.add === 'function') {
          /* BekateqCart kuemmert sich um Bubble-/Counter-/Drawer-Refresh inkl.
             Drawer-Oeffnen. Die Helper-eigenen Button-States (pdp-buy-btn--success
             etc.) treffen unseren Button nicht \u2014 Erfolg/Fehler-Feedback ueber
             Promise-Hooks setzen. */
          atcBtn.disabled = true;
          window.BekateqCart.add(items, null, { originalText: originalHTML })
            .then(pbFlashSuccess)
            .catch(function(err) {
              console.error('[Projektberater] BekateqCart.add error:', err);
              pbFlashError();
            });
          return;
        }

        /* Fallback ohne Helper: roher /cart/add.js + cart:refresh-Event. */
        atcBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(function(r) { if (!r.ok) throw new Error('Cart error'); return r.json(); })
        .then(function() {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          pbFlashSuccess();
        })
        .catch(pbFlashError);
      });
    }

    /* --- Navigation Buttons --- */
    var nextBtns = root.querySelectorAll('[data-pb-next]');
    var prevBtns = root.querySelectorAll('[data-pb-prev]');
    var restartBtns = root.querySelectorAll('[data-pb-restart]');

    for (var nb = 0; nb < nextBtns.length; nb++) {
      nextBtns[nb].addEventListener('click', function() { goToStep(currentStep + 1); });
    }

    for (var pb = 0; pb < prevBtns.length; pb++) {
      prevBtns[pb].addEventListener('click', function() {
        if (typeof onLegacyPrev === 'function' && onLegacyPrev(currentStep)) return;
        /* Bei Result-Step und uebersprungenem Calculator: direkt zurueck
           zu Step 0 (Auswahl) statt durch den leeren Calc-Step. */
        if (currentStep === 2 && !productNeedsCalculator()) {
          goToStep(0);
          return;
        }
        goToStep(currentStep - 1);
      });
    }

    /* Section-Anfang in den Viewport scrollen — wird nach Restart aufgerufen,
       damit der User nicht weiter unten am Result-Step verbleibt. */
    function scrollToTop() {
      if (root && typeof root.scrollIntoView === 'function') {
        try { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        catch (e) { root.scrollIntoView(); }
      }
    }

    for (var rb = 0; rb < restartBtns.length; rb++) {
      restartBtns[rb].addEventListener('click', function() {
        if (typeof onLegacyRestart === 'function' && onLegacyRestart()) {
          scrollToTop();
          return;
        }
        selectedBlock = null;
        for (var i = 0; i < cards.length; i++) {
          cards[i].classList.remove('is-selected');
          cards[i].setAttribute('aria-pressed', 'false');
        }
        var step1Next = steps[0].querySelectorAll('[data-pb-next]');
        for (var sn = 0; sn < step1Next.length; sn++) {
          step1Next[sn].disabled = true;
        }
        goToStep(0);
        scrollToTop();
      });
    }

    /* Double-click card to jump directly to step 2 */
    for (var dc = 0; dc < cards.length; dc++) {
      (function(card) {
        card.addEventListener('dblclick', function() {
          selectCard(card);
          goToStep(1);
        });
      })(cards[dc]);
    }

    /* ================================================================
       ADAPTIVE MODE (Phase 2 — Filter-Steps Anwendung/Fläche/Untergrund)

       Liest data-pb-products, aggregiert die unique Werte pro Filter-Feld
       der noch passenden Produkte, ueberspringt leere/eindeutige Steps
       automatisch und liefert am Ende einen Handoff-Screen mit den
       gefilterten Produkten. Phase 3 verdrahtet den Handoff mit dem
       Calculator-Step (selectedBlock + goToStep(1)).

       Wenn die Collection keine Filter-Daten hat, bleibt der Legacy-
       Wizard (oben) sichtbar und der adaptive Controller deaktiviert
       sich selbst.
       ================================================================ */
    (function initAdaptiveController() {
      var pbProducts = [];
      try {
        var pbEl = root.querySelector('[data-pb-products]');
        if (pbEl) pbProducts = JSON.parse(pbEl.textContent);
      } catch(e) { console.warn('[Projektberater] data-pb-products parse failed', e); return; }

      /* Set verf\u00fcgbarer Sprite-Icon-Namen (v3): aus data-pb-icon-names. Wenn
         ein Metaobjekt einen Icon-Namen enth\u00e4lt, der nicht im Sprite ist,
         f\u00e4llt die Karte graceful auf Label-only zur\u00fcck. */
      var iconNames = {};
      try {
        var inEl = root.querySelector('[data-pb-icon-names]');
        if (inEl) {
          var arr = JSON.parse(inEl.textContent) || [];
          for (var iN = 0; iN < arr.length; iN++) iconNames[arr[iN]] = true;
        }
      } catch(e) { /* graceful: leeres Set */ }

      var FILTER_KEYS = ['anwendung', 'bauteil', 'untergrund'];
      var FIELD_MAP = { anwendung: 'anwendung', bauteil: 'bauteil', untergrund: 'untergrund' };
      var LABEL_MAP = {
        anwendung: pbI18n.indicator_anwendung || 'Anwendung',
        bauteil: pbI18n.indicator_bauteil || 'Fl\u00E4che',
        untergrund: pbI18n.indicator_untergrund || 'Untergrund'
      };

      function hasFilterableData(products) {
        for (var i = 0; i < products.length; i++) {
          var p = products[i];
          for (var k = 0; k < FILTER_KEYS.length; k++) {
            var arr = p[FIELD_MAP[FILTER_KEYS[k]]];
            if (Array.isArray(arr) && arr.length > 0) return true;
          }
        }
        return false;
      }

      if (pbProducts.length === 0 || !hasFilterableData(pbProducts)) return;

      var filterViewport = root.querySelector('[data-pb-filter-viewport]');
      if (!filterViewport) return;

      var legacyIndicator = root.querySelector('[data-pb-indicator-legacy]');
      var legacyViewport = root.querySelector('[data-pb-legacy-viewport]');
      var adaptiveIndicator = root.querySelector('[data-pb-indicator-adaptive]');

      if (legacyIndicator) legacyIndicator.hidden = true;
      if (legacyViewport) legacyViewport.style.display = 'none';
      filterViewport.hidden = false;
      if (adaptiveIndicator) adaptiveIndicator.hidden = false;

      /* Weg 1 (09.10.2026): auf thematischen Collections faellt der
         Anwendungs-Step weg — die Seite IST die Anwendung. Gesteuert
         ueber custom.projektberater_skip_anwendung, siehe Kommentar im
         Liquid. Ohne Flag bleibt das Verhalten unveraendert. */
      var skipAnwendung = root.getAttribute('data-pb-skip-anwendung') === 'true';

      var filterState = { anwendung: null, bauteil: null, untergrund: null };
      var stepSequence = [];
      var stepIdx = 0;

      /* Chronologische Liste aller Step-\u00DCberg\u00E4nge (manuelle Auswahl,
         \u00DCberspringen, auto-skip). Pro Eintrag: { key, val, isAuto, skipped? }.
         Quelle f\u00FCr sauberes Back \u00FCber auto-\u00FCbersprungene Steps. */
      var navHistory = [];

      /* Phase 4: Farbton-Auswahl. selectedFarbe wird in handoffToCalculator
         als Filter-Kriterium auf product.variants angewendet (nur Varianten
         mit passendem v.farbe gehen in den Calculator). */
      var selectedFarbe = null;
      var lastFarbtonProduct = null;

      /* v3: Filter-Arrays sind jetzt Objekte {label, icon, sortierung}.
         aggregateUnique dedupliziert über .label (stable key), behält das
         erste gesehene {icon, sortierung}-Paar und sortiert nach
         .sortierung asc (fehlende Werte ans Ende). filterProducts und
         filterState arbeiten weiterhin mit dem reinen Label-String. */
      function aggregateUnique(products, fieldKey) {
        var byLabel = {};
        var field = FIELD_MAP[fieldKey];
        for (var i = 0; i < products.length; i++) {
          var arr = products[i][field];
          if (!Array.isArray(arr)) continue;
          for (var j = 0; j < arr.length; j++) {
            var e = arr[j];
            if (!e) continue;
            var label = (typeof e === 'string') ? e : e.label;
            if (!label) continue;
            if (!byLabel[label]) {
              byLabel[label] = {
                label: label,
                icon: (e && e.icon) || '',
                sortierung: (e && e.sortierung != null) ? Number(e.sortierung) : 9999
              };
            }
          }
        }
        var list = [];
        for (var k in byLabel) { if (byLabel.hasOwnProperty(k)) list.push(byLabel[k]); }
        list.sort(function(a, b) {
          if (a.sortierung !== b.sortierung) return a.sortierung - b.sortierung;
          return a.label.localeCompare(b.label);
        });
        return list;
      }

      function arrayHasLabel(arr, label) {
        if (!Array.isArray(arr)) return false;
        for (var i = 0; i < arr.length; i++) {
          var e = arr[i];
          var l = (typeof e === 'string') ? e : (e && e.label);
          if (l === label) return true;
        }
        return false;
      }

      function filterProducts(products, state) {
        return products.filter(function(p) {
          for (var k = 0; k < FILTER_KEYS.length; k++) {
            var key = FILTER_KEYS[k];
            if (!state[key]) continue;
            if (!arrayHasLabel(p[FIELD_MAP[key]], state[key])) return false;
          }
          return true;
        });
      }

      function getCurrentProducts() { return filterProducts(pbProducts, filterState); }

      function resolveStepSequence() {
        /* Pre-flight: welche Filter-Keys haben global \u00FCberhaupt eine
           Auswahl (>=2 unique Werte)? Keys mit nur 1 globalen Wert werden
           direkt fixiert (User sieht sie nie). Das kontextuelle Skippen
           je nach aktueller Auswahl macht danach advanceFrom dynamisch. */
        var seq = [];
        for (var i = 0; i < FILTER_KEYS.length; i++) {
          var key = FILTER_KEYS[i];
          /* Uebersprungen heisst auch: nicht auto-fixen. Ein in filterState
             gesetzter Wert wuerde die Produktmenge still einschraenken. */
          if (skipAnwendung && key === 'anwendung') continue;
          var unique = aggregateUnique(pbProducts, key);
          if (unique.length >= 2) {
            seq.push(key);
          } else if (unique.length === 1) {
            filterState[key] = unique[0].label;
          }
        }
        /* Traegt die Collection ausschliesslich anwendung-Daten, bliebe nach
           dem Ueberspringen kein Step uebrig und der Berater spraenge direkt
           in den Handoff. Eine Frage ist besser als keine — dann gilt das
           Flag fuer diese Collection nicht. */
        if (seq.length === 0 && skipAnwendung) {
          var fallback = aggregateUnique(pbProducts, 'anwendung');
          if (fallback.length >= 2) seq.push('anwendung');
        }
        return seq;
      }

      function escapeHtml(s) {
        var d = document.createElement('div');
        d.appendChild(document.createTextNode(s == null ? '' : String(s)));
        return d.innerHTML;
      }

      /* Dynamisches Vorr\u00FCcken \u2014 Kern der drei Review-Punkte (Phase 2):
         - jeder Step aggregiert seine Karten aus getCurrentProducts()
         - 0 Produkte \u00FCberhaupt \u2192 Sackgasse \u2192 Empty-State
         - 0 unique Werte f\u00FCr key \u2192 Attribut nicht gepflegt, weiter ohne fix
         - 1 unique Wert \u2192 auto-fix in filterState, in navHistory, weiter
         - >=2 unique Werte \u2192 normaler Filter-Step
         - nach allen Filter-Keys \u2192 Handoff (oder Empty wenn 0 Produkte) */
      function advanceFrom(startIdx) {
        var idx = startIdx;
        while (idx < stepSequence.length) {
          if (getCurrentProducts().length === 0) {
            return { kind: 'empty', idx: idx };
          }
          var key = stepSequence[idx];
          var unique = aggregateUnique(getCurrentProducts(), key);
          if (unique.length === 0) {
            idx++;
            continue;
          }
          if (unique.length === 1) {
            filterState[key] = unique[0].label;
            navHistory.push({ key: key, val: unique[0].label, isAuto: true });
            idx++;
            continue;
          }
          return { kind: 'step', idx: idx };
        }
        if (getCurrentProducts().length === 0) {
          return { kind: 'empty', idx: stepSequence.length };
        }
        return { kind: 'handoff', idx: stepSequence.length };
      }

      function proceed(fromIdx) {
        var r = advanceFrom(fromIdx);
        if (r.kind === 'empty') showEmptyState(r.idx);
        else if (r.kind === 'step') showStep(r.idx);
        else showHandoff();
      }

      function hideAllSteps() {
        /* MUSS den Farbton-Container mitnehmen — der hat kein
           [data-pb-filter-step] sondern ein eigenes [data-pb-filter-farbton].
           Wurde er nicht ausgeblendet, ergab das beim Zurueck-Klick zwei
           sichtbare Steps + zwei Zurueck-Buttons + sich aufstapelnde DOMs. */
        var allSteps = filterViewport.querySelectorAll('[data-pb-filter-step], [data-pb-filter-handoff], [data-pb-filter-farbton]');
        for (var i = 0; i < allSteps.length; i++) allSteps[i].hidden = true;
      }

      function hasManualHistory() {
        for (var i = 0; i < navHistory.length; i++) {
          if (!navHistory[i].isAuto) return true;
        }
        return false;
      }

      function renderStepIndicator() {
        if (!adaptiveIndicator) return;
        adaptiveIndicator.innerHTML = '';
        var labels = stepSequence.map(function(k) { return LABEL_MAP[k]; })
          .concat([
            pbI18n.indicator_auswahl || 'Auswahl',
            pbI18n.indicator_berechnung || 'Berechnung',
            pbI18n.indicator_ergebnis || 'Ergebnis'
          ]);
        labels.forEach(function(label, i) {
          var dot = document.createElement('div');
          var isPast = i < stepIdx;
          var isCurrent = i === stepIdx;
          dot.className = 'pb__step-dot' + ((isPast || isCurrent) ? ' is-active' : '') + (isPast ? ' is-completed is-clickable' : '');
          dot.setAttribute('data-dot', String(i));
          dot.innerHTML = (i + 1) + '<span class="pb__step-label">' + escapeHtml(label) + '</span>';
          if (isPast) {
            dot.setAttribute('role', 'button');
            dot.setAttribute('tabindex', '0');
            dot.setAttribute('aria-label', (pbI18n.indicator_jump_aria || 'Zurueck zu Schritt') + ' ' + (i + 1) + ': ' + label);
            (function(targetIdx) {
              dot.addEventListener('click', function() { jumpToIndicatorStep(targetIdx); });
              dot.addEventListener('keydown', function(e) {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  jumpToIndicatorStep(targetIdx);
                }
              });
            })(i);
          }
          adaptiveIndicator.appendChild(dot);
          if (i < labels.length - 1) {
            var line = document.createElement('div');
            line.className = 'pb__step-line' + (i < stepIdx ? ' is-active' : '');
            adaptiveIndicator.appendChild(line);
          }
        });
      }

      /* Indikator-Sprung NUR rueckwaerts. labels[] = stepSequence (Filter) +
         [Auswahl, Berechnung, Ergebnis]. */
      function jumpToIndicatorStep(targetIdx) {
        if (targetIdx >= stepIdx) return; /* defensiv: kein Vorspringen */
        pbTrack('pb_indicator_jump', { from_step: stepIdx, to_step: targetIdx });
        var n = stepSequence.length;
        if (targetIdx < n) {
          /* Zurueck zu einem Filter-Step: Werte ab targetIdx zuruecksetzen,
             navHistory von den entsprechenden Eintraegen befreien, Result/
             Calculator schliessen und Filter-Step rendern. */
          for (var j = targetIdx; j < n; j++) {
            filterState[stepSequence[j]] = null;
          }
          navHistory = navHistory.filter(function(h) {
            var hIdx = stepSequence.indexOf(h.key);
            return hIdx >= 0 && hIdx < targetIdx;
          });
          selectedBlock = null;
          selectedFarbe = null;
          lastFarbtonProduct = null;
          if (legacyViewport) legacyViewport.style.display = 'none';
          filterViewport.hidden = false;
          showStep(targetIdx);
          return;
        }
        if (targetIdx === n) {
          /* Auswahl-Slot (Handoff / Farbton) */
          selectedBlock = null;
          if (legacyViewport) legacyViewport.style.display = 'none';
          filterViewport.hidden = false;
          if (lastFarbtonProduct) {
            showFarbtonStep(lastFarbtonProduct);
          } else {
            showHandoff();
          }
          return;
        }
        if (targetIdx === n + 1) {
          /* Berechnung-Step (legacy step 1) — nur wenn selectedBlock vorhanden */
          if (!selectedBlock) return;
          if (filterViewport) filterViewport.hidden = true;
          if (legacyViewport) legacyViewport.style.display = '';
          goToStep(1);
        }
      }

      function showStep(idx) {
        stepIdx = idx;
        hideAllSteps();
        var key = stepSequence[idx];
        var stepEl = filterViewport.querySelector('[data-pb-filter-step="' + key + '"]');
        if (!stepEl) return;
        stepEl.hidden = false;
        renderFilterCards(stepEl, key);
        var back = stepEl.querySelector('[data-pb-filter-back]');
        if (back) back.hidden = !hasManualHistory();
        renderStepIndicator();
        pbTrack('pb_step_view', {
          step: key,
          position: idx + 1,
          total_steps: stepSequence.length
        });
      }

      function showHandoff() {
        stepIdx = stepSequence.length;
        hideAllSteps();
        var handoff = filterViewport.querySelector('[data-pb-filter-handoff]');
        if (handoff) handoff.hidden = false;
        renderHandoff();
        renderStepIndicator();
        var products = getCurrentProducts();
        pbTrack('pb_handoff_view', {
          product_count: products.length,
          state: JSON.stringify(filterState)
        });
      }

      function showEmptyState(idx) {
        stepIdx = idx;
        hideAllSteps();
        pbTrack('pb_empty_state', { at_step: idx, state: JSON.stringify(filterState) });
        var handoff = filterViewport.querySelector('[data-pb-filter-handoff]');
        if (!handoff) return;
        handoff.hidden = false;
        var titleEl = handoff.querySelector('[data-pb-handoff-title]');
        var subEl = handoff.querySelector('[data-pb-handoff-sub]');
        var grid = handoff.querySelector('[data-pb-handoff-grid]');
        var nextBtn = handoff.querySelector('[data-pb-handoff-next]');
        if (titleEl) titleEl.textContent = pbI18n.empty_title || 'Keine Produkte f\u00FCr diese Auswahl';
        if (subEl) subEl.textContent = pbI18n.empty_subtitle || 'Bitte gehen Sie zur\u00FCck und passen Sie eine Auswahl an.';
        if (grid) grid.innerHTML = '';
        if (nextBtn) nextBtn.disabled = true;
        delete handoff.dataset.selectedHandle;
        renderStepIndicator();
      }

      function renderFilterCards(stepEl, key) {
        var grid = stepEl.querySelector('[data-pb-filter-grid]');
        if (!grid) return;
        var entries = aggregateUnique(getCurrentProducts(), key);
        grid.innerHTML = '';
        if (entries.length === 0) {
          /* Defensive: advanceFrom sollte das abfangen \u2014 falls nicht, Hinweis. */
          var hint = document.createElement('p');
          hint.className = 'pb__filter-subtitle';
          hint.textContent = pbI18n.empty_filter_no_values || 'Keine Werte f\u00FCr diesen Filter \u2014 bitte gehen Sie zur\u00FCck.';
          grid.appendChild(hint);
          return;
        }
        entries.forEach(function(entry) {
          var val = entry.label;
          var card = document.createElement('div');
          card.className = 'pb__type-card';
          card.tabIndex = 0;
          card.setAttribute('role', 'button');
          card.setAttribute('aria-pressed', 'false');
          var iconHtml = '';
          if (entry.icon && iconNames[entry.icon]) {
            iconHtml = '<div class="pb__type-icon"><svg viewBox="0 0 24 24" width="48" height="48" aria-hidden="true"><use href="#pb-icon-' + entry.icon + '"/></svg></div>';
          }
          card.innerHTML = iconHtml + '<h4 class="pb__type-title">' + escapeHtml(val) + '</h4>';
          card.addEventListener('click', function() { handleSelect(key, val); });
          card.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleSelect(key, val); }
          });
          grid.appendChild(card);
        });
      }

      function handleSelect(key, val) {
        filterState[key] = val;
        navHistory.push({ key: key, val: val, isAuto: false });
        pbTrack('pb_filter_select', { filter: key, value: val });
        /* Attribution Option A: used_projektberater als GA4 user_property.
           Einmal pro Window — beim ersten Filter-Klick markieren, damit
           Sessions mit/ohne Berater im Umsatz vergleichbar werden. */
        if (!window.__pbUsedFlagSet && window.bekTrack && typeof window.bekTrack.setUserProperty === 'function') {
          window.bekTrack.setUserProperty({ used_projektberater: 'true' });
          window.__pbUsedFlagSet = true;
        }
        var keyIdx = stepSequence.indexOf(key);
        proceed(keyIdx + 1);
      }

      function handleSkip() {
        /* Skip ohne Werte-Fixierung \u2014 aber als manueller Eintrag tracken,
           damit Back diesen Step wieder zeigt. */
        var currentKey = stepSequence[stepIdx];
        navHistory.push({ key: currentKey, val: null, isAuto: false, skipped: true });
        pbTrack('pb_filter_skip', { filter: currentKey });
        proceed(stepIdx + 1);
      }

      function handleBack() {
        pbTrack('pb_filter_back', { from_step: stepIdx, state: JSON.stringify(filterState) });
        /* Pop bis zum letzten manuellen Eintrag (Auswahl oder Skip);
           filterState aller dazwischen auto-fixed Eintr\u00E4ge reverten. */
        while (navHistory.length > 0) {
          var last = navHistory.pop();
          if (last.key && filterState[last.key] === last.val) {
            filterState[last.key] = null;
          }
          if (!last.isAuto) {
            var idx = stepSequence.indexOf(last.key);
            if (idx >= 0) {
              showStep(idx);
              return;
            }
          }
        }
        proceed(0);
      }

      function renderHandoff() {
        var handoff = filterViewport.querySelector('[data-pb-filter-handoff]');
        if (!handoff) return;
        var titleEl = handoff.querySelector('[data-pb-handoff-title]');
        var subEl = handoff.querySelector('[data-pb-handoff-sub]');
        var grid = handoff.querySelector('[data-pb-handoff-grid]');
        var nextBtn = handoff.querySelector('[data-pb-handoff-next]');
        var products = getCurrentProducts();

        if (titleEl) {
          var titleTpl = pbI18n.handoff_title_html || 'Ihre Auswahl passt zu <span data-pb-handoff-count>__PB_COUNT__</span> Produkt(en)';
          titleEl.innerHTML = titleTpl.replace('__PB_COUNT__', String(products.length));
        }
        if (subEl) subEl.textContent = pbI18n.handoff_subtitle || 'Im n\u00E4chsten Schritt berechnen wir die ben\u00F6tigte Menge.';
        if (nextBtn) nextBtn.disabled = true;
        delete handoff.dataset.selectedHandle;

        if (!grid) return;
        grid.innerHTML = '';
        products.forEach(function(p) {
          var card = document.createElement('div');
          card.className = 'pb__type-card';
          card.tabIndex = 0;
          card.setAttribute('role', 'button');
          card.setAttribute('aria-pressed', 'false');
          card.setAttribute('data-handoff-handle', p.handle);
          var img = p.image ? '<img src="' + escapeHtml(p.image) + '" alt="" loading="lazy" style="width:60px;height:60px;object-fit:contain;margin-bottom:.4rem;">' : '';
          card.innerHTML = img + '<h4 class="pb__type-title">' + escapeHtml(p.title) + '</h4>';
          card.addEventListener('click', function() {
            var cards = grid.querySelectorAll('.pb__type-card');
            for (var i = 0; i < cards.length; i++) {
              cards[i].classList.remove('is-active');
              cards[i].setAttribute('aria-pressed', 'false');
            }
            card.classList.add('is-active');
            card.setAttribute('aria-pressed', 'true');
            handoff.dataset.selectedHandle = p.handle;
            if (nextBtn) nextBtn.disabled = false;
          });
          grid.appendChild(card);
        });
        if (products.length === 1) {
          var first = grid.querySelector('.pb__type-card');
          if (first) first.click();
        }
      }

      /* Liefert eindeutige Farben des Produkts inkl. erstem passendem
         Variantenbild für die Vorschau. Trim + Skip leerer Strings, damit
         Whitespace-Varianten und nicht-gepflegte Optionen nicht als „echte"
         Farbe zählen — sonst greift der < 2 Farben-Auto-Skip nicht sauber. */
      function getFarbenForProduct(product) {
        var byFarbe = {};
        var vars = (product && product.variants) || [];
        for (var i = 0; i < vars.length; i++) {
          if (!vars[i].available) continue;
          var f = (vars[i].farbe || '').trim();
          if (!f) continue;
          if (!byFarbe[f]) {
            byFarbe[f] = { farbe: f, image: vars[i].image || null };
          } else if (!byFarbe[f].image && vars[i].image) {
            byFarbe[f].image = vars[i].image;
          }
        }
        var list = [];
        for (var k in byFarbe) { if (byFarbe.hasOwnProperty(k)) list.push(byFarbe[k]); }
        list.sort(function(a, b) { return a.farbe.localeCompare(b.farbe); });
        return list;
      }

      /* RAL→Hex-Map fuer Farbton-Swatches. Wird genutzt, wenn die Variante
         kein Variantenbild hat (Shopify-Variant ohne Image). Key ist der
         numerische RAL-Code als String, Wert der Hex-Approximation laut
         offizieller RAL-Tabelle. Erweitern, sobald ein neuer Ton im Shop
         auftaucht — Lookup ist case-/whitespace-tolerant (siehe pbRalHex). */
      var PB_RAL_HEX = {
        '1015': '#E6D2B5', /* Hellelfenbein */
        '1023': '#FAD201', /* Verkehrsgelb */
        '3000': '#AF2B1E', /* Feuerrot */
        '3020': '#C7172E', /* Verkehrsrot */
        '5010': '#0E294B', /* Enzianblau */
        '5012': '#1E5193', /* Lichtblau */
        '6005': '#114232', /* Moosgruen */
        '6018': '#57A639', /* Gelbgruen */
        '7001': '#8F9695', /* Silbergrau */
        '7016': '#293133', /* Anthrazitgrau */
        '7032': '#B9B9A8', /* Kieselgrau */
        '7035': '#D7D7D7', /* Lichtgrau */
        '7040': '#989EA1', /* Fenstergrau */
        '8003': '#7B5141', /* Lehmbraun */
        '8011': '#5B3A29', /* Nussbraun */
        '8017': '#44322D', /* Schokoladenbraun */
        '9001': '#FDF4E3', /* Cremeweiss */
        '9005': '#0A0A0A', /* Tiefschwarz */
        '9006': '#A5A5A5', /* Weissaluminium */
        '9010': '#F1ECDF', /* Reinweiss */
        '9016': '#F6F6F6'  /* Verkehrsweiss */
      };

      function pbRalHex(name) {
        if (!name) return null;
        var m = String(name).match(/RAL\s*(\d{3,4})/i);
        if (!m) return null;
        return PB_RAL_HEX[m[1]] || null;
      }

      function showFarbtonStep(product) {
        lastFarbtonProduct = product;
        stepIdx = stepSequence.length; /* bleibt im „Auswahl"-Slot */
        hideAllSteps();
        var farben = getFarbenForProduct(product);
        pbTrack('pb_farbton_view', {
          product_handle: product.handle,
          farben_count: farben.length
        });
        var stepEl = filterViewport.querySelector('[data-pb-filter-farbton]');
        if (!stepEl) return;
        stepEl.hidden = false;
        var grid = stepEl.querySelector('[data-pb-farbton-grid]');
        if (grid) {
          grid.innerHTML = '';
          var farben = getFarbenForProduct(product);
          farben.forEach(function(entry) {
            var farbe = entry.farbe;
            var card = document.createElement('div');
            card.className = 'pb__type-card pb__farbton-card';
            card.tabIndex = 0;
            card.setAttribute('role', 'button');
            card.setAttribute('aria-pressed', 'false');
            /* Drei-stufiger Swatch-Fallback:
                 1) Variantenbild → <img>
                 2) RAL-Code im Namen + Map-Treffer → farbige Flaeche
                 3) sonst neutraler Platzhalter (graceful) */
            var swatch;
            if (entry.image) {
              swatch = '<div class="pb__farbton-img"><img src="' + escapeHtml(entry.image) + '" alt="" loading="lazy"></div>';
            } else {
              var hex = pbRalHex(farbe);
              if (hex) {
                swatch = '<div class="pb__farbton-swatch pb__farbton-swatch--ral" aria-hidden="true" style="background:' + hex + '"></div>';
              } else {
                swatch = '<div class="pb__farbton-swatch" aria-hidden="true"></div>';
              }
            }
            card.innerHTML = swatch + '<h4 class="pb__type-title">' + escapeHtml(farbe) + '</h4>';
            card.addEventListener('click', function() { handleFarbtonSelect(farbe); });
            card.addEventListener('keydown', function(e) {
              if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleFarbtonSelect(farbe); }
            });
            grid.appendChild(card);
          });
        }
        renderStepIndicator();
      }

      function handleFarbtonSelect(farbe) {
        selectedFarbe = farbe;
        var hasImg = false, hasHex = false;
        if (lastFarbtonProduct) {
          var farben = getFarbenForProduct(lastFarbtonProduct);
          for (var i = 0; i < farben.length; i++) {
            if (farben[i].farbe === farbe) { hasImg = !!farben[i].image; break; }
          }
          hasHex = !!pbRalHex(farbe);
        }
        pbTrack('pb_farbton_pick', {
          farbe: farbe,
          has_image: hasImg,
          has_swatch_hex: hasHex,
          product_handle: lastFarbtonProduct ? lastFarbtonProduct.handle : ''
        });
        if (lastFarbtonProduct) handoffToCalculator(lastFarbtonProduct, farbe);
      }

      function proceedAfterHandoff(product) {
        pbTrack('pb_handoff_product', {
          product_handle: product.handle,
          product_title: product.title,
          calc_mode: product.calc_mode || 'none'
        });
        /* Wenn das Produkt mehrere verfügbare Farben hat → Farbton-Step.
           Sonst (0 oder 1 Farbe) direkt zum Calculator; bei 1 Farbe wird
           sie automatisch übernommen. */
        var farben = getFarbenForProduct(product);
        if (farben.length >= 2) {
          showFarbtonStep(product);
        } else {
          selectedFarbe = farben.length === 1 ? farben[0].farbe : null;
          lastFarbtonProduct = null;
          handoffToCalculator(product, selectedFarbe);
        }
      }

      function handoffToCalculator(product, farbe) {
        /* Synthetisches selectedBlock — setupCalculator/calculate/showResult
           lesen aus selectedBlock.getAttribute, dadurch bleibt der
           Legacy-Calc/Result-Code unverändert. Wenn ein Farbton gewählt
           wurde, werden die Variants vorab gefiltert, damit packVariants
           nur farbpassende Größen verwendet. */
        var variants = (product.variants || []).slice();
        if (farbe) {
          variants = variants.filter(function(v) { return v.farbe === farbe; });
        }
        var fakeBlock = document.createElement('div');
        fakeBlock.setAttribute('data-calc-mode', String(product.calc_mode || 'flaeche'));
        fakeBlock.setAttribute('data-verbrauch', String(product.verbrauch || '0.3'));
        fakeBlock.setAttribute('data-anstriche', String(product.anstriche || '1'));
        fakeBlock.setAttribute('data-dichte', String(product.dichte || '0'));
        fakeBlock.setAttribute('data-product-handle', product.handle);
        if (product.url) fakeBlock.setAttribute('data-product-url', product.url);
        fakeBlock.setAttribute('data-product-title', product.title);
        if (product.image) fakeBlock.setAttribute('data-product-image', product.image);
        if (farbe) fakeBlock.setAttribute('data-product-farbe', farbe);
        fakeBlock.setAttribute('data-product-zubehoer', JSON.stringify(product.zubehoer || []));
        /* aufbauempfehlung ist ein Array von Objekten {step, title, text,
           product_handle} — als JSON serialisieren statt direkt auf
           setAttribute (sonst wird daraus '[object Object]'). */
        fakeBlock.setAttribute('data-product-aufbau', JSON.stringify(product.aufbauempfehlung || null));
        fakeBlock.setAttribute('data-product-variants', JSON.stringify(variants));
        selectedBlock = fakeBlock;
        filterViewport.hidden = true;
        if (legacyViewport) legacyViewport.style.display = '';
        goToStep(1);
      }

      /* Wire skip/back/handoff/farbton buttons (event-delegation auf filterViewport) */
      filterViewport.addEventListener('click', function(e) {
        var skip = e.target.closest && e.target.closest('[data-pb-filter-skip]');
        if (skip) { handleSkip(); return; }
        var back = e.target.closest && e.target.closest('[data-pb-filter-back]');
        if (back) { handleBack(); return; }
        var fback = e.target.closest && e.target.closest('[data-pb-farbton-back]');
        if (fback) {
          /* Farbton-Step zurück → Handoff. Farbton-Auswahl verwerfen. */
          selectedFarbe = null;
          lastFarbtonProduct = null;
          showHandoff();
          return;
        }
        var next = e.target.closest && e.target.closest('[data-pb-handoff-next]');
        if (next && !next.disabled) {
          var handoff = filterViewport.querySelector('[data-pb-filter-handoff]');
          var handle = handoff && handoff.dataset.selectedHandle;
          var product = null;
          for (var i = 0; i < pbProducts.length; i++) {
            if (pbProducts[i].handle === handle) { product = pbProducts[i]; break; }
          }
          if (!product) return;
          proceedAfterHandoff(product);
        }
      });

      /* Adaptive-Bridge: dock an goToStep / Prev / Restart an. */
      onLegacyStep = function(idx) {
        /* Indicator-Sync: idx 1 → Berechnung, idx 2 → Ergebnis
           (positioniert hinter stepSequence + Auswahl-Slot). */
        if (idx >= 1) {
          stepIdx = stepSequence.length + idx;
          renderStepIndicator();
        }
      };

      onLegacyPrev = function(legacyStep) {
        /* Calc-Step Zurück → zurück zum Farbton-Step (falls aktiv) oder
           Handoff (statt Legacy Step 0). Wenn der Calc-Step uebersprungen
           wurde (non-flaeche), greift dieselbe Rueckkehr aus dem Result-Step. */
        var skippedCalc = (legacyStep === 2 && !productNeedsCalculator());
        if (legacyStep === 1 || skippedCalc) {
          if (legacyViewport) legacyViewport.style.display = 'none';
          filterViewport.hidden = false;
          if (lastFarbtonProduct) {
            showFarbtonStep(lastFarbtonProduct);
          } else {
            showHandoff();
          }
          return true;
        }
        return false;
      };

      onLegacyRestart = function() {
        /* Restart im adaptive Mode: filterState + navHistory + selectedBlock
           + Farbton-State reset, zurück zum ersten meaningful Filter-Step. */
        pbTrack('pb_restart', { from_state: JSON.stringify(filterState) });
        filterState = { anwendung: null, bauteil: null, untergrund: null };
        navHistory = [];
        selectedBlock = null;
        selectedFarbe = null;
        lastFarbtonProduct = null;
        if (legacyViewport) legacyViewport.style.display = 'none';
        filterViewport.hidden = false;
        stepSequence = resolveStepSequence();
        proceed(0);
        return true;
      };

      stepSequence = resolveStepSequence();
      proceed(0);
    })();
  }

  function bootstrap() {
    var roots = document.querySelectorAll('.collection-projektberater[data-section-id]');
    for (var i = 0; i < roots.length; i++) {
      try { initProjektberater(roots[i]); }
      catch (e) { console.error('[Projektberater] init failed:', e); }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
